
export default
	props: blog:
		type: Object
		required: true

	computed:
		category: -> @blog.blogCategories?[0]?.title
		date: ->
			date = new Date @blog.dateCreated
			date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })

		readTime: -> @blog.readTime


